@if (currentMessage) {
  <div class="error-banner" role="alert">
    <lucide-icon name="circle-alert" class="error-banner__icon" [size]="18"></lucide-icon>
    <span class="error-banner__message">{{ currentMessage }}</span>
    <button
      type="button"
      class="error-banner__dismiss"
      (click)="dismiss()"
      aria-label="Dismiss error">
      <lucide-icon name="x" [size]="16"></lucide-icon>
    </button>
  </div>
}
